import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// All admin API calls use withCredentials for httpOnly cookie auth
const api = axios.create({ baseURL: API, withCredentials: true });

export const adminApi = {
  login: (username, password) => api.post("/admin/login", { username, password }),
  logout: () => api.post("/admin/logout"),
  me: () => api.get("/admin/me"),
  getOrders: () => api.get("/admin/orders"),
  getTrashedOrders: () => api.get("/admin/orders/trash"),
  restoreOrder: (id) => api.post(`/admin/orders/${id}/restore`),
  purgeOrder: (id) => api.delete(`/admin/orders/${id}/purge`),
  createOrder: (orderData) => api.post("/admin/orders", orderData),
  updateOrder: (id, fields) => api.put(`/admin/orders/${id}/update`, fields),
  updateOrderStatus: (id, status, tracking_number) => api.put(`/admin/orders/${id}/status`, { status, tracking_number: tracking_number || "" }),
  exportOrders: () => api.get("/admin/orders/export", { responseType: "blob" }),
  deleteOrder: (id) => api.delete(`/admin/orders/${id}`),
  getContacts: () => api.get("/admin/contacts"),
  getAnalytics: () => api.get("/admin/analytics"),
  getGallery: () => api.get("/admin/gallery"),
  uploadGallery: (form) => api.post("/admin/gallery/upload", form),
  deleteGallery: (id) => api.delete(`/admin/gallery/${id}`),
  // Reviews
  getReviews: () => api.get("/admin/reviews"),
  approveReview: (id) => api.put(`/admin/reviews/${id}/approve`),
  rejectReview: (id) => api.put(`/admin/reviews/${id}/reject`),
  deleteReview: (id) => api.delete(`/admin/reviews/${id}`),
  // Reveals
  getReveals: () => api.get("/admin/reveals"),
  approveReveal: (id) => api.put(`/admin/reveals/${id}/approve`),
  rejectReveal: (id) => api.put(`/admin/reveals/${id}/reject`),
  deleteReveal: (id) => api.delete(`/admin/reveals/${id}`),
  getCountdown: () => api.get("/admin/countdown"),
  updateCountdown: (config) => api.put("/admin/countdown", config),
  sendEmail: (data) => api.post("/admin/send-email", data),
};
